import { warn } from "./warn";

const TTL_MS = 30 * 60 * 1000;

const write = (key, value) => {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({ ...value, expiresAt: Date.now() + TTL_MS })
    );
  } catch (e) {
    warn(`failed to store ${key}`, e);
  }
};

const read = key => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    const { expiresAt, ...value } = JSON.parse(raw);
    return Date.now() > expiresAt ? null : value;
  } catch (e) {
    return null;
  }
};

const remove = key => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    warn(`failed to remove ${key}`, e);
  }
};

/**
 * entry reason of the signup prompt a guest last saw, so it can be attached to
 * `signup_completed` after the form submit or the Google OAuth round trip
 */
const ENTRY_KEY = "bds_signup_entry";

export const stashEntryReason = ({ reason, surface }) =>
  write(ENTRY_KEY, { reason, surface });

export const peekEntryReason = () => {
  const entry = read(ENTRY_KEY);
  return entry?.reason ? entry : null;
};

export const clearEntryReason = () => remove(ENTRY_KEY);

/**
 * which form started a Google OAuth round trip ("signup" | "signin"), so the
 * return trip knows what the user was attempting
 */
const GOOGLE_FROM_KEY = "bds_google_auth_from";

export const stashGoogleAuthFrom = from => write(GOOGLE_FROM_KEY, { from });

// read once: removes the key so a later sign-in can't pick up a stale value
export const consumeGoogleAuthFrom = () => {
  const value = read(GOOGLE_FROM_KEY);
  remove(GOOGLE_FROM_KEY);
  return value?.from || null;
};
